var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'default')?_c('vue-element-loading',{attrs:{"active":_vm.active,"is-full-screen":true}}):_vm._e(),(_vm.type === 'container')?_c('vue-element-loading',{attrs:{"color":_vm.themeStyles.primaryColor.color,"active":_vm.active,"is-full-screen":false,"spinner":"mini-spinner"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }